<svelte:options accessors/>
<script>
    import {createEventDispatcher} from "svelte";
    import NauiSlideOver from "../../../naui/layout/NauiSlideOver.svelte";
    import NauiCheckbox from "../../../naui/atoms/NauiCheckbox.svelte";
    import NauiInput from "../../../naui/atoms/NauiInput.svelte";
    import NauiTextarea from "../../../naui/atoms/NauiTextarea.svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";

    const events = new createEventDispatcher();

    export let open;
    export let data;

    function cambioCheckboxDesisteOtro() {
        if (data.otro) {
            data.detalle_otro = '';
        }
    }
</script>
<div>
    <NauiSlideOver title="Cliente desiste" bind:open={open}>
        <p>Por favor especifique las razones por las que el cliente desistió</p>

        <NauiCheckbox label="Autosolución" bind:value={data.autosolucion}/>
        <NauiCheckbox label="Competencia" bind:value={data.competencia}/>
        <NauiCheckbox label="Disponibilidad" bind:value={data.disponibilidad}/>
        <NauiCheckbox label="No interesado" bind:value={data.no_interesado}/>
        <NauiCheckbox label="Precio" bind:value={data.precio}/>
        <NauiCheckbox label="Reporte" bind:value={data.reporte}/>
        <NauiCheckbox label="Tamaño" bind:value={data.tamano}/>
        <NauiCheckbox label="Ubicación" bind:value={data.ubicacion}/>
        <NauiCheckbox label="Otro"
                      on:input={cambioCheckboxDesisteOtro}
                      bind:value={data.otro}/>
        <NauiInput label="¿Cuál?"
                   bind:value={data.detalle_otro}
                   isDisabled={!data.otro}/>

        <NauiTextarea label="Observaciones" bind:value={data.observaciones}/>

        <div slot="actions">
            <div class="max-w-300px mx-auto">
                <NauiButton on:click={() => {events('save', data)}}
                            caption="GUARDAR"
                            mode="stroked"
                            color="accent"
                            className="w-100 mb-1" />
            </div>
        </div>
    </NauiSlideOver>
</div>